import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";
import React, { useEffect, useState } from "react";
import { useMemo } from "react";
import { useSelector } from "react-redux";
import DataTable from "../../../components/data-table";
import { currencyFormat } from "../../../helpers";
import ordersService from "../../../services/orders.service";
import FormModalContent from "./form";
import OrderStatusBadge from "./status-badge";

import { TextField } from "@material-ui/core";
import MuiAutocomplete from "@material-ui/lab/Autocomplete";
import brandsService from "../../../services/brands.service";
import glassesService from "../../../services/glasses.service";


const defaultKeys = [
    {
        field: "trackingCode",
        title: "کد رهگیری",
        active: true,
    },
    {
        field: "user.phoneNumber",
        title: "شماره تلفن",
        active: true,
    },
    {
        field: "transaction.gatewayTransactionId",
        title: "شناسه تراکنش اسنپ‌پی",
        active: true,
    },
];

export default function OrdersPage() {
    const { initials } = useSelector((state) => state.app);

    const [options, setOptions] = useState({
        brands: []
    })

    const [filters, setFilters] = useState({
        page: 1,
        perpage: 10,
        brandId: null,
        glass: null,
        user: null
    })

    const headerCells = useMemo(
        () => [
            {
                field: "trackingCode",
                title: "کد رهگیری",
                disableSort: true,
            },
            {
                field: "user",
                title: "نام مشتری",
                renderer: (v) => <span className="">{v.fullName}</span>,
            },
            {
                field: "user",
                title: "شماره تلفن",
                renderer: (v) => <span className="en">{v.phoneNumber}</span>,
            },
            {
                field: "status",
                title: "وضعیت",
                disableSort: true,
                renderer: (v) => <OrderStatusBadge status={v} initials={initials} />,
            },
            {
                field: "paymentProvider",
                title: "نوع پرداخت",
                renderer: (v) => {
                    return (
                        <span className="">{v}</span>
                    )
                },
            },
            {
                field: "payableAmount",
                title: "مبلغ پرداختی",
                renderer: (v) => currencyFormat(v),
            },
            {
                field: "totalAmount",
                title: "مبلغ فاکتور",
                renderer: (v) => currencyFormat(v),
            },
            //   {
            //     field: "fullName",
            //     title: "نام",
            //   },
            {
                field: "deliveryDate",
                title: "تاریخ تحویل",
                date: true,
            },
            {
                field: "createDate",
                title: "تاریخ ایجاد",
                date: true,
            },
            //   {
            //     field: "nationalCode",
            //     title: "کد ملی",
            //   },
            //   {
            //     field: "email",
            //     title: "ایمیل",
            //   },
        ],
        [initials]
    );


    const filterForm = useMemo(
        () =>
            !initials || !options.brands
                ? undefined
                : {
                    form: [
                        {
                            _type: "autocomplete",
                            _empty: "",
                            name: "brandIds",
                            options: options.brands.map(item => ({ ...item, value: item.id, title: item.name })),
                            valueSelector: "value",
                            labelSelector: "title",
                            label: "برندها",
                            disableClearable: false,
                        },
                        {
                            _type: "customContent",
                            content: function SearchContent(values) {
                                const [selected, setSelected] = useState(null)
                                const [glasses, setGlasses] = useState([])
                                const searchInGlassTitle = async (e) => {
                                    const search = e.target.value;
                                    const res = await glassesService.getGlasses([`search=${search}`])
                                    setGlasses(res.data.items);
                                }

                                const getOptionLabel = () => {
                                    const labelSelector = "name";
                                    if (!labelSelector) return;
                                    if (typeof labelSelector === "string") {
                                        return (option) => `${option[labelSelector]}`;
                                    }
                                    return labelSelector;
                                };

                                const changeInGlassTitle = (e, value) => {
                                    if (!value) {
                                        values.setFieldValue("glassId", "")
                                        values.setFieldValue("glass", null)
                                        setSelected(null)
                                        return;
                                    }
                                    values.setFieldValue("glassId", value.id)
                                    values.setFieldValue("glass", value)
                                    setSelected(value)
                                }

                                return (
                                    <>
                                        <MuiAutocomplete
                                            name="glassId"
                                            multiple={false}
                                            options={glasses}
                                            onKeyUp={searchInGlassTitle}
                                            getOptionLabel={getOptionLabel()}
                                            defaultValue={values.values.glass}
                                            noOptionsText="هیچ گزینه ای یافت نشد."
                                            onChange={changeInGlassTitle}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    margin="normal"
                                                    variant="outlined"
                                                    fullWidth
                                                    label={"مدل عینک"}
                                                    InputProps={{
                                                        ...params.InputProps,
                                                        endAdornment: (
                                                            <React.Fragment>
                                                                {params.InputProps.endAdornment}
                                                            </React.Fragment>
                                                        ),
                                                    }}
                                                />
                                            )}
                                        />
                                    </>
                                )
                            }
                        },
                        {
                            _type: "autocomplete",
                            _empty: null,
                            name: "status",
                            options: initials.enums.orderStatus,
                            valueSelector: "value",
                            labelSelector: "title",
                            label: "وضعیت",
                        },
                    ],
                },
        [initials, options]
    );

    const getBrands = async () => {
        const brands = await brandsService.getAllBrands();
        setOptions(prev => ({
            ...prev,
            brands: brands.data
        }))
    }

    useEffect(() => {
        getBrands()
    }, [])

    return (
        <div className="p-3">
            <DataTable
                headCells={headerCells}
                searchKeys={defaultKeys}
                rowActions={[
                    {
                        modalProps: { maxWidth: "md" },
                        icon: <InfoOutlinedIcon />,
                        modalContent: (props) => <FormModalContent {...props} />,
                    }
                ]}
                backend={ordersService.getOrdersUrl}
                title="سفارشات"
                order={{ order: "DESC", orderBy: "createDate" }}
                filterForm={filterForm}
            />
        </div>
    );
}
